<template>
    <NavCromi v-if="isCromi()" />

    <NavRent v-if="isRent()" />

    <NavRadioguide v-if="isRadioguide()" />
</template>

<script lang="ts" setup>
import NavCromi from '~/components/layouts/header/NavCromi.vue'
import NavRadioguide from '~/components/layouts/header/NavRadioguide.vue'
import NavRent from '~/components/layouts/header/NavRent.vue'
</script>
